// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  uid: __t.string().primaryKey(),
  restaurantId: __t.u64().name("restaurant_id"),
  defId: __t.string().name("def_id"),
  x: __t.f32(),
  z: __t.f32(),
  rotY: __t.f32().name("rot_y"),
  floor: __t.u32(),
  parentUid: __t.string().name("parent_uid"),
  slotIndex: __t.i32().name("slot_index"),
  localRotY: __t.f32().name("local_rot_y"),
});
